import React from 'react'
// import get from 'lodash/get'
import { Row, Col } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'

class OrderSummary extends React.Component {
  renderOrderTotalInfo = orderInfo => {
    const { isDefault = false, label, value } = orderInfo
    return (
      <>
        {isDefault === true && (
          <Col
            xs={12}
            key={label}
            className="d-flex order-totals align-items-end text-capitalize">
            <span className="w-100">{label}</span>
            <span className="w-100">{value}</span>
          </Col>
        )}
      </>
    )
  }
  renderPayment = paymentInfo => {
    const { isDefault = false, label, value, PaymentType } = paymentInfo
    const displayLabel = PaymentType === 'Chile_WebPay' ? 'ChileWebPay:' : label
    return (
      <>
        {isDefault === true && (
          <Col
            xs={12}
            className="d-flex payment-total align-items-end text-capitalize">
            <span className="w-100">{displayLabel}</span>
            <span className="w-100">{value}</span>
          </Col>
        )}
      </>
    )
  }

  render() {
    const orderTotalInfo = this.props?.item?.[0]?.orderTotalInfo || []
    const payment = this.props?.item?.[0]?.payments || []
    return (
      <Row noGutters className="mb-4">
        <Row
          noGutters
          className="w-100 order-payment-details text-uppercase mt-2">
          <Col xs={6} className="order-total-border text-center">
            {i18nTranslate('orderPrint.orderTotalsTitle', 'Order Totals')}
          </Col>
          <Col xs={6} className="text-center">
            {i18nTranslate('orderPrint.paymentsTitle', 'Payments')}
          </Col>
        </Row>
        <Col xs={6} className="order-total-wrapper mt-1">
          {orderTotalInfo.length > 0 &&
            orderTotalInfo.map(this.renderOrderTotalInfo)}
        </Col>
        <Col xs={6} className="payment-total-wrapper mt-1">
          {payment.length > 0 && payment.map(this.renderPayment)}
        </Col>
      </Row>
    )
  }
}

export default OrderSummary
export { OrderSummary }
